import { gsap } from 'gsap';
import { debounce as _debounce } from 'underscore';
import slideshowCtrl        from './slideshowCtrl';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el:                   false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'module_slideshow_variable_width';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){
    	this.$html = $('html');
        this.$win  = $(window);
        this.initSlider(true);
	}

    initSlider(b){
        let $s =  this.$el.find( '.slider-container' ), args, centerMode, $n, infinite, slidesToShow;
        if ( b ){

            this.onResize();

            /*
            $s.find( '.slick-slider' ).on( 'beforeChange', (event, slick, currentSlide, nextSlide) =>{
                
            });
           
            $s.find( '.slick-slider' ).on( 'afterChange', (event, slick, currentSlide ) =>{
                
            });
            */

            $s.find( '.slick-slider' ).on( 'init', (event, slick, currentSlide ) =>{
                this.centerSlides();
            });

            $n              =   this.$el.find( '.slide-wrap' ).length;
            centerMode      =   $n <= 3;
            infinite        =   $n > 3;
            slidesToShow    =   $n <= 3 ? $n : 1;

            args = {
                dots: false,

                // don't repeat if there are only 3 slides
                infinite: infinite,

                slidesToScroll: 1,
                slidesToShow: slidesToShow,

                // center slides only if there is one image ...
                centerMode: centerMode,
                
                variableWidth: true,
                arrows: true,
                autoplay: false,
                prevArrow : $s.find('.arrow.left'),
                nextArrow : $s.find('.arrow.right'),

                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            arrows: false,
                            slidesToScroll: 1,
                            slidesToShow: 1,
                            centerMode: false
                        }
                    }
                ]
            }
            // important: Remember to pass the dom element!!!
            this.slider = new slideshowCtrl( {
                $el : $s,
                customArgs: true,
                args: args
            });

            setTimeout( ()=>this.delayInit(), 100 );

        }
        else{
            this.slider.destroy();
        }

        this.addEvents( b );       
    }

    delayInit(){
        this.$el.find( '.slider-container' ).addClass( 'ready' );
    }

    addEvents(b){
        this.debounceResize(b);
    }

    setSliderIndex( i ){
        let $slick = this.slider.getSlider();
        $slick.slick( 'slickGoTo', i );
    }

    //---------------------------------------- COMMONS -----------------------------------------//
    debounceResize(b){
        if ( b ){
            // debounce resize
            this._debResize = _debounce( () => this.onResize(), 137 );
            this.$win.on( 'resize', this._debResize );
        }
        else{
            if ( this._debResize ){
                this._debResize.cancel();
                this.$win.off( 'resize', this._debResize );
            }        
        }
    }

    // where the magic happen
    onResize(){
        let $img_wrapper, orw, orh, fixh, $layout;
        this.$el.find( '.slide-wrap' ).each( (i,el) => {

            $img_wrapper = $(el).find( '.img-wrapper' );
            orw  = parseInt( $img_wrapper.attr( 'data-width' ) );
            orh  = parseInt( $img_wrapper.attr( 'data-height' ) );

            $layout = $img_wrapper.parents( '.layout' );
            fixh = $layout.height();

            $img_wrapper.css({
                'height': fixh,
                'padding-bottom': '0%',
                'width': Math.round( orw/orh*fixh )
            }).removeClass( 'autosize' );

        });

        this.centerSlides();
    }
    // where the magic happen
    centerSlides(){
        let $s =  this.$el.find( '.slick-slider' ), n = $s.find( '.slick-slide' ).length, dx, w, margin;
        if ( $s.hasClass( 'slick-initialized' ) ){
            if ( n > 1 && n <=3 ){
                w = 0;
                $s.find( '.slick-slide' ).each( (i,el)=>{
                    if ( i === 0 ){
                        // as it's centered, we calculate the width of the first slides and the margins between slides!
                        margin = $(el).width()/2 + parseInt( $(el).find( '.layout' ).css('margin-left') )*2*(n-1);
                    }
                    w += $(el).width();
                })
                //console.log( w + ' , ' + $s.width() + ' , ' + margin )
                if ( w < $s.width() ){
                    // center the slides
                    dx = - (w - margin)/2;
                }
                else{
                    // reset
                    dx = 0;
                }
                gsap.set( $s.find( '.slick-slide' ), {x:dx} );
            }
        }
    }

    destroy(){
		if ( this.$el.length > 0){
            this.initSlider( false );
    	}
    }

}


